import React from "react";
import { useSelector } from "react-redux";
import { useFirestoreConnect, isLoaded } from "react-redux-firebase";
import SortableTable from "../../components/common/tables/SortableTable";
import LoadingIndicator from "../../components/common/LoadingIndicator";
import { Link } from "react-router-dom";
import {
  ADMIN_MENU_PATH,
  ADMIN_RESTAURANTS_PATH,
  USER_PROMOS_PATH,
} from "../../constants/paths";

const AdminHomePage = () => {
  useFirestoreConnect([
    { collection: "restaurants" }, // or 'todos'
  ]);
  const restaurants = useSelector(
    (state) => state.firestore.ordered.restaurants
  );

  if (!isLoaded(restaurants)) return <LoadingIndicator />;

  return (
    <div className="px-16 py-8 text-gray-900">
      <h3 className="text-2xl font-bold">Restaurantes</h3>
      <SortableTable
        columns={columns}
        data={restaurants}
        NoDataComponent={NoDataComponent}
      />
      <div className="bg-white mt-4 shadow-sm border rounded-sm">
        <p className="px-6 py-3 border-b">Acciones</p>
        <div className="bg-gray-100 px-6 py-3 relative text-gray-700 text-md">
          <div className="mb-2">
            <Link className="font-semibold" to={ADMIN_MENU_PATH}>
              Manejar menú
            </Link>
            <p className="text-sm">Editar datos del menú.</p>
          </div>
          <div className="mb-2">
            <Link className="font-semibold" to={USER_PROMOS_PATH}>
              Manejar carrusel
            </Link>
            <p className="text-sm">Editar carrusel de imágenes</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const columns = [
  {
    Header: "Sucursal",
    accessor: "address",
  },
  {
    Header: "Datos",
    accessor: (values) => {
      return (
        <Link
          to={`${ADMIN_RESTAURANTS_PATH}/${values.id}`}
          className="font-bold text-gray-700"
        >
          Editar
        </Link>
      );
    },
  },
];

const NoDataComponent = () => {
  return (
    <div className="flex justify-center bg-white shadow-md py-16 flex-wrap text-gray-700">
      <h3 className="text-center text-4xl w-full font-bold">
        No tienes ningún restaurante todavía
      </h3>
    </div>
  );
};

export default AdminHomePage;
